// ? Login module routes
import { RouteNames } from '@/router/routeNames';
import type { RouteRecordRaw } from 'vue-router';
import PayMethodChange from '../policy/PolicyMyPolicy/components/PayMethod/PayMethodChange.vue';
import BankAccountTypeChange from '../policy/PolicyMyPolicy/components/PaymentInfo2/BankAccountTypeChange.vue';
import UpdateBeneficiary from '../policy/components/UpdateBeneficiaries/UpdateBeneficiary.vue';
import PaymentMethod from '../policy/components/PaymentMethod/PaymentMethod.vue';
import WithDrawalDate from '../policy/components/WithDrawalDate/WithDrawalDate.vue';
import DashboardLayout from '@/layouts/DashboardLayout.vue';

const routes: RouteRecordRaw = {
  name: RouteNames.WIZARD_PAGES,
  component: DashboardLayout,
  path: 'wizards',
  meta: {
    pageTitle: 'Landing.WizardPages',
  },
  children: [
    {
      name: RouteNames.PAYMETHODCHANGE,
      path: 'payMethodChange',
      component: PayMethodChange,
    },
    {
      name: RouteNames.BENEFICIARY_STEP,
      path: 'beneficiary',
      component: UpdateBeneficiary,
    },
    {
      name: RouteNames.PAYMENT_STEP,
      path: 'payment',
      component: PaymentMethod,
    },
    {
      name: RouteNames.WITHDRAWALDATESTEP,
      path: 'withdrawalDate',
      component: WithDrawalDate,
    },
    {
      name: RouteNames.CHANGEBANKACCOUNTSTEP,
      path: 'changeBankAccount',
      component: BankAccountTypeChange,
    },
  ],
};

export default routes;
